import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { sportCategories } from "@/mocks/events";

export default function CategoryQuickLinks() {
  return (
    <section className="mx-auto w-full max-w-[1200px] px-4 py-12 md:px-6 md:py-16">
      <SectionHeading
        eyebrow="Sport Categories"
        title="选择你的主场"
        description="三大热门项目分区呈现，点击进入即可浏览该项目的全部赛事实时动态。"
      />
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {sportCategories.map((cat) => (
          <Link
            key={cat.key}
            to={`/category/${cat.key}`}
            className="group relative flex h-[280px] flex-col justify-end overflow-hidden rounded-lg border border-background-200 p-6 cursor-pointer md:h-[320px]"
          >
            <img
              src={cat.image}
              alt={`${cat.name}赛事直播`}
              title={`${cat.name}直播 - jrs直播`}
              className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/70 to-transparent" />
            <div className="relative">
              <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-500/90 text-background-50">
                <i className={`${cat.icon} text-xl`} />
              </span>
              <h3 className="mt-4 font-heading text-xl font-bold text-foreground-950">
                {cat.name}直播
              </h3>
              <p className="mt-1 text-xs font-medium uppercase tracking-[0.15em] text-primary-400">
                {cat.tagline}
              </p>
              <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
                {cat.description}
              </p>
              <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-foreground-800 transition-colors group-hover:text-primary-400">
                进入{cat.name}专区
                <i className="ri-arrow-right-line" />
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}